import { toNano } from '@ton/core';

export const JETTON_TRANSFER_GAS_FEES = toNano('0.048');
